import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { GraduationCap, Play, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const LessonOfWeek = ({ user, onOpen }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!user) { setData(null); return undefined; }
    const load = () => api.get("/team/lesson").then((r) => setData(r.data)).catch(() => setData(null));
    load();
    window.addEventListener("beatflow:lesson-changed", load);
    return () => window.removeEventListener("beatflow:lesson-changed", load);
  }, [user]);

  if (!data?.lesson) return null;
  const { tab, teacher, note } = data.lesson;

  const unpin = async () => {
    try {
      await api.delete("/team/lesson");
      setData({ ...data, lesson: null });
      toast.success("Lesson unpinned");
    } catch (e) {
      toast.error("Could not unpin");
    }
  };

  return (
    <div className="mb-12 rounded-2xl border border-[#ffab00]/30 bg-gradient-to-r from-[#ffab00]/10 to-transparent p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="lesson-of-week">
      <GraduationCap className="w-8 h-8 text-[#ffab00] shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="text-[10px] font-tab uppercase tracking-[0.3em] text-[#ffab00]">Lesson of the week{teacher && !data.is_owner ? ` · from ${teacher}` : ""}</div>
        <div className="font-heading text-xl uppercase tracking-tight truncate" data-testid="lesson-title">{tab.title}{tab.artist ? <span className="text-slate-500 text-sm normal-case"> — {tab.artist}</span> : null}</div>
        {note && <p className="text-sm text-slate-400 line-clamp-2 mt-1" data-testid="lesson-note">{note}</p>}
      </div>
      <div className="flex gap-2 shrink-0">
        <Button onClick={() => onOpen(tab)} className="bg-[#ffab00] text-black hover:bg-[#ffc233] font-semibold" data-testid="lesson-open-button">
          <Play className="w-4 h-4 mr-2" /> Open lesson
        </Button>
        {data.is_owner && (
          <Button variant="outline" size="icon" onClick={unpin} className="border-white/15 bg-white/5" title="Unpin" data-testid="lesson-unpin-button">
            <X className="w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  );
};
